import { render } from "./detail.vue?vue&type=template&id=2f046664&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=2f046664&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f046664"

export default script